import { useQuery } from '@tanstack/react-query';
import ServiceManager from '../services/ServiceManager';

// --- Types ---

export interface ClientListVariables {
    search?: string;
    pageNumber?: number;
    pageSize?: number;
}

/**
 * Interface representing the structure of the API response
 */
export interface ClientListResponse {
    contactClient: any[]; // Replace 'any' with your specific Client interface
    total: number;
    [key: string]: any;
}

// --- Hook ---

export const useClientList = (
    variables: ClientListVariables = {},
    additionalFilters: ((data: ClientListResponse) => ClientListResponse) | null = null,
) => {
    const { search, pageNumber, pageSize } = variables;

    const {
        data,
        error,
        isLoading,
        isFetching,
    } = useQuery<ClientListResponse>({
        queryKey: ['getClients', search, pageNumber, pageSize],
        enabled: true, // Manual refetch triggered by useEffect
        retry: true,
        queryFn: async () => {
            const response = await ServiceManager.customClientService('search', [{
                filter: search,
                pageNumber,
                pageSize,
            }]);

            let responseData = response?.data;

            if (typeof additionalFilters === 'function') {
                responseData = additionalFilters(response?.data);
            }

            return responseData;
        },
        staleTime: 1000 * 60 * 5, // 5 minutes
        gcTime: 1000 * 60 * 10, // 10 minutes
    });

    return {
        data: data?.contactClient || [],
        isLoading: isFetching || isLoading,
        error,
        totalCount: data?.total,
    };
};
